import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import { useUser } from "../Commonfunction/UserContext";
import { useLocation } from "react-router-dom";

const validationSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  intimation_date: Yup.string().required("Intimation date is required"),
  state_id: Yup.string().required("State is required"),
  cutoff_date: Yup.string().required("Cutoff date is required"),
});

const CutOffDateForm = ({ onClose, id, fetchData, fetchDataUserAccess }) => {
  const location = useLocation();

  const { userAccess } = useUser();
  const [singleData, setSingleData] = useState();
  const [stateData, setStateData] = useState();
  const userName = localStorage.getItem("username");

  const singleCountyData = async () => {
    try {
      const result = await getData(
        `/api/get-financial-year-cutoff-date-by-id/${id}`
      );
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const apiStateData = async () => {
    try {
      const result = await getData("/api/all-states");
      if (result.success) {
        const data = result?.data?.map((items) => ({
          label: items?.state_name,
          value: items?.id,
        }));
        setStateData(data);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    id && singleCountyData();
  }, [id]);

  useEffect(() => {
    apiStateData();
  }, []);

  const handleSubmit = async (finalValue) => {
    try {
      const request_url = id
        ? `/api/update-financial-year-cutoff-date/${id}`
        : "/api/create-financial-year-cutoff-date";
      const postDataResult = await postData(request_url, finalValue);

      if (postDataResult.success) {
        toast.success(postDataResult.message);
        location.pathname === "/dashboard" && fetchDataUserAccess();
        onClose();
        fetchData && fetchData();
      } else {
        toast.error(postDataResult.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        title: id ? singleData?.title : "",
        state_id: id ? singleData?.state_id : "",
        cutoff_date: id ? dayjs(singleData?.financial_start) : null, // Initialize with the start of the day
        intimation_date: id ? dayjs(singleData?.intimation_date) : null, // Initialize with the start of the day minus 10 days
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const finalValue = {
          title: values.title,
          cutoff_date: values?.cutoff_date.format("MM-DD-YYYY"),
          intimation_date: values?.intimation_date.format("MM-DD-YYYY"),
        };
        handleSubmit(finalValue);
      }}
    >
      {({ errors, touched, setFieldValue, values }) => (
        <Form>
          <div className="form-body">
            <div className="grid-row">
              <div className="grid-col-6">
                <div className="form-group">
                  <label htmlFor="financial_start">
                    State
                    <span className="valid-msg">*</span>
                  </label>
                  <Field
                    id="state_id"
                    name="state_id"
                    component={CustomSelect}
                    options={stateData}
                    menuPosition="none"
                    // isMulti={true}
                    style={{
                      color: "red",
                    }}
                    className={
                      errors.state_id && touched.state_id ? "input-error" : ""
                    }
                  />
                  <ErrorMessage
                    name="state_id"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>

              <div className="grid-col-6">
                <div className="form-group">
                  <label htmlFor="title">
                    Title <span className="text-red">*</span>
                  </label>
                  <Field
                    id="title"
                    name="title"
                    type="text"
                    placeholder="Please enter title"
                    className={
                      errors.title && touched.title ? "input-error" : ""
                    }
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
            </div>
            <div className="grid-row">
              <div className="grid-col-6">
                <div className="form-group">
                  <label htmlFor="cutoff_date">
                    Cut Off Date
                    <span className="valid-msg">*</span>
                  </label>
                  <input
                    type="date"
                    id="cutoff_date"
                    name="cutoff_date"
                    className={`usa-input ${
                      errors.cutoff_date && touched.cutoff_date
                        ? "usa-input--error"
                        : ""
                    }`}
                    value={
                      values.cutoff_date
                        ? dayjs(values.cutoff_date).format("YYYY-MM-DD")
                        : ""
                    }
                    min={dayjs().startOf("month").format("YYYY-MM-DD")}
                    max={dayjs().endOf("month").format("YYYY-MM-DD")}
                    onChange={(e) => {
                      const selectedDate = dayjs(e.target.value).startOf("day");
                      setFieldValue("cutoff_date", selectedDate);
                      setFieldValue(
                        "intimation_date",
                        selectedDate.subtract(10, "day")
                      );
                    }}
                  />
                  <ErrorMessage
                    name="cutoff_date"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>

              <div className="grid-col-6">
                <div className="form-group">
                  <label htmlFor="title">
                    Intimation Date <span className="text-red">*</span>
                  </label>
                  <input
                    type="date"
                    id="intimation_date"
                    name="intimation_date"
                    className={`usa-input ${
                      errors.intimation_date && touched.intimation_date
                        ? "usa-input--error"
                        : ""
                    }`}
                    value={
                      values.intimation_date
                        ? dayjs(values.intimation_date).format("YYYY-MM-DD")
                        : ""
                    }
                    readOnly
                    onChange={(e) => {
                      setFieldValue(
                        "intimation_date",
                        dayjs(e.target.value).startOf("day")
                      );
                    }}
                  />
                  <ErrorMessage
                    name="intimation_date"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-footer">
            <button type="button" className="btn btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-submit">
              Submit
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CutOffDateForm;
